import { TextareaAutosize } from "@mui/material";

const AutosizeTextarea = ({ textFor, text, handleText, disabled }) => {
    return (
        <TextareaAutosize
            style={{
                padding: "8px",
                width: "100%",
                minHeight: "80px",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                resize: "none",
                outline: "none",
                border: "none",
                borderRadius: "5px",
                boxShadow: "0 0 0 1px #1717171a"
            }}
            placeholder={`Write your ${textFor} here...`}
            value={text}
            onChange={handleText}
            disabled={disabled}
        />
    );
}

export default AutosizeTextarea;